<template>
    <!-- come ordinare -->
    <div class="container-md container-app p-0 ">
        <div class="wrapper login">
            <h1 class="title-nobkg text-center"><b>{{$t('scegli_come_ordinare')}}</b></h1><br>
            <div class="content text-center">
                <button v-for="service in this.getRestaurantServices(true)" class="btn btn-default btn-tipologia"
                        @click="handleZones(service)">
                    <img :src="getImage(service)" class="mb-3" width="50">
                    <div>{{getName(service)}}</div>
                    <span>{{getDescription(service)}}</span>
                </button>
                <button v-if="!!$route.query.canGoBack" class="btn btn-default btn-sm mt-3" @click="$router.go(-1)">
                    « {{$t('btn_indietro')}}
                </button>
            </div>
        </div>
    </div>
</template>

<script>
import {mapActions, mapGetters, mapState} from 'vuex';

export default {
    name: 'TypeSelect',
    computed: {
        ...mapState('restaurant', {
            service_points: state => state.punti_di_servizio,
            locali: state => state.locali,
            locale: state => state.locale,
            franchising: state => state.franchising,
            f_distretto: state => state.f_distretto
        }),
        ...mapState('order', {
            order: state => state
        }),
        ...mapGetters('restaurant', {
            getRestaurantServices: 'restaurantServices',
            getServiceInfo: 'serviceInfo'
        }),
        ...mapGetters('order', {
            cartMustBeReset: 'cartMustBeReset'
        })
    },
    methods: {
        getImage: function (service) {
            return this.getServiceInfo(service, null).img;
        },
        getName: function (service) {
            return this.getServiceInfo(service, null).nome;
        },
        getDescription: function (service) {
            return this.getServiceInfo(service, null).descrizione;
        },
        gotoRestaurantSelection: function (service, point = null) {
            let rooms = this.locali;
            if (point) {
                const roomsIds = point.conf_ordini_prenotazioni_pds.map(
                    (conf) => conf.id_locale,
                );

                rooms = this.locali.filter((room) => {
                    return roomsIds.includes(room.id);
                });
            }

            if (this.franchising && rooms.length > 1) {
                this.$router.push({
                    name: 'rooms',
                    query: {canGoBack: this.$route.query.canGoBack, service: service, pointId: point?.id}
                });
            } else if (rooms.length) {
                const resetHome = (reset) => {
                    if (reset) {
                        this.resetOrder();
                    }
                    this.setLocale(rooms[0]);
                    this.setDefaultParams({
                        id_punto_di_servizio_default: point?.id,
                        type_default: service
                    });

                    this.$router.push({name: 'home'});
                };

                if (this.cartMustBeReset(rooms[0].id)) {
                    this.showModalCartReset({
                        show: true,
                        callback: (success) => {
                            if (success) {
                                resetHome(true);
                            }
                        }
                    });
                } else {
                    resetHome(false);
                }
            }
        },
        handleZones: function (service) {
            if (service === 'DIL') {
                if (this.service_points.length > 1) {
                    this.$router.push({
                        name: 'rooms.zone',
                        query: {canGoBack: this.$route.query.canGoBack, service}
                    });
                } else if (this.service_points.length) {
                    this.gotoRestaurantSelection(service, this.service_points[0]);
                }
            } else if (this.f_distretto && service === 'DELIVERY') {
                this.$router.push({
                    name: 'rooms.address',
                    query: {canGoBack: this.$route.query.canGoBack, service}
                });
            } else {
                this.gotoRestaurantSelection(service);
            }
        },
        ...mapActions('global', [
            'showModalCartReset'
        ]),
        ...mapActions('order', {
            resetOrder: 'reset',
            setDefaultParams: 'setDefaultParams'
        }),
        ...mapActions('restaurant', [
            'setLocale'
        ]),
    }
}
</script>
